import { FilterTypeNames, type OldToNewSeveralRowsProps } from 'entities/history';
import { getKeys } from 'shared/lib/object';
import type { SettingType } from 'entities/campaign-groups';
import { formatPrice } from 'shared/lib/formatting';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import { OldToNewValue } from './OldToNewValue';

const valueMapper = (
  change: keyof typeof FilterTypeNames,
  valueObj: { condition: SettingType['condition']; value: string | null }
) => {
  const { condition, value } = valueObj;

  if (!value) {
    return 'Not applied';
  }

  const formatter =
    change === 'min_income' ? (value: string) => formatPrice(value, undefined, true) : (value: string) => `${value}%`;

  switch (condition) {
    case 'gte':
      return `More than ${formatter(value)}`;
    case 'lte':
      return `Less than ${formatter(value)}`;
    case 'eq':
      return `Equal ${formatter(value)}`;
    case 'range': {
      const [from, to] = value.split('|');

      return `From ${formatter(from)} to ${formatter(to)}`;
    }
    default:
      break;
  }
};

export function OldToNewSeveralRows({ data }: OldToNewSeveralRowsProps) {
  const transformedData = getKeys(data)
    .filter((change) => {
      // THIS IS A BAD WORKAROUND, GET RID OF IT LATER
      const areBothValuesNull = data[change].old.value === null && data[change].new.value === null;

      return !areBothValuesNull;
    })
    .map((change) => {
      const oldValue = valueMapper(change, data[change].old);
      const newValue = valueMapper(change, data[change].new);

      return {
        filterName: FilterTypeNames[change],
        oldValue,
        newValue,
      };
    });

  return (
    <div data-testid="TestId__several_rows_value">
      {transformedData.map(({ filterName, oldValue, newValue }) => (
        <div
          className="flex items-center border-b border-slate-100 py-2 text-xs last:border-0"
          key={filterName}
          {...getDataAutoTestAttributes([`${filterName.toLowerCase().replace(' ', '-')}`]).attributes}
        >
          <span className="mr-[5px] font-semibold">{filterName}:</span>
          <OldToNewValue
            type="text"
            oldValue={oldValue}
            newValue={newValue}
          />
        </div>
      ))}
    </div>
  );
}
